<template>
  <div class="flex min-h-screen bg-white">
    <!-- Sidebar -->
    <div
      class="flex flex-col w-16 bg-white shadow-md border-r border-gray-200"
      v-if="isMenuVisible"
    >
      <!-- Logo -->
      <div class="flex justify-center py-8">
        <router-link to="/">
          <div class="flex items-center justify-center">
            <img src="@/assets/image/logo.jpg" alt="Logo" class="h-8 w-auto" />
          </div>
        </router-link>
      </div>

      <!-- Menu Items -->
      <div
        class="flex flex-col items-center space-y-6 mt-[2rem]"
        v-if="isDataLoaded"
      >
        <component
          v-for="(item, index) in filteredMenuItems"
          :key="index"
          :is="item.isLogout || item.disabled ? 'div' : 'router-link'"
          :to="!item.isLogout && !item.disabled ? item.link : undefined"
          class="flex justify-center items-center w-10 h-10 text-gray-500 transition cursor-pointer relative"
          :class="{
            'text-purple-600 bg-white rounded-lg':
              $route.path === item.link && !item.disabled,
            'opacity-50 cursor-not-allowed pointer-events-none': item.disabled,
          }"
          :title="!item.disabled ? item.name : ''"
          :style="item.customClass"
          @click="item.isLogout ? handleLogout() : null"
        >
          <img
            :src="
              require(`@/${
                $route.path === item.link && !item.disabled && !item.isLogout
                  ? item.activeIcon
                  : item.icon
              }`)
            "
            alt="Menu icon"
            class="h-6 w-6"
          />
        </component>
      </div>
      <!-- Loading indicator for menu -->
      <div v-else class="flex flex-col items-center space-y-6 mt-[4rem]">
        <div class="w-10 h-10 rounded-lg bg-gray-200 animate-pulse"></div>
        <div class="w-10 h-10 rounded-lg bg-gray-200 animate-pulse"></div>
        <div class="w-10 h-10 rounded-lg bg-gray-200 animate-pulse"></div>
        <div class="w-10 h-10 rounded-lg bg-gray-200 animate-pulse"></div>
      </div>
    </div>

    <!-- Main Content -->
    <div class="flex-1">
      <!-- Topbar -->
      <div class="bg-white shadow-sm">
        <div class="px-4 py-4 flex items-center justify-between">
          <div class="ml-[1rem]">
            <img src="@/assets/image/logo-text.png" alt="" />
          </div>
          <div class="relative flex-1 max-w-lg"></div>

          <!-- Right Side -->
          <div class="flex items-center space-x-2 gap-[10px]">
            <!--            <button @click="toggleTheme">-->
            <!--              {{ isDark ? "☀️" : "🌙" }}-->
            <!--            </button>-->
            <div class="ml-2">
              <img
                :src="userAvatar"
                alt="User Avatar"
                class="w-9 h-9 rounded-full object-cover cursor-pointer"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- Page Content -->
      <div class="p-4 bg-white">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import { useMenuController } from "@/composables/useTriggerMenu";

import http from "@/http";
import { ElMessageBox, ElMessage } from "element-plus";

export default {
  setup() {
    const { isMenuVisible } = useMenuController();

    return {
      isMenuVisible,
    };
  },
  data() {
    return {
      userInfo: {},
      permissions: [],
      isDataLoaded: false,
      isDark: false,
      userAvatar:
        "https://images.unsplash.com/photo-1633332755192-727a05c4013d?q=80&w=1000&auto=format&fit=crop",
      menuItems: [
        {
          name: "Bosh sahifa",
          icon: "assets/image/home.png",
          activeIcon: "assets/image/home-active.png",
          link: "/main/home",
          permissions: [110, 120, 130],
          disabled: false,
        },
        {
          name: "To'langanlar",
          icon: "assets/image/payed.png",
          activeIcon: "assets/image/payed-active.png",
          link: "/main/payed",
          permissions: [110, 120, 130],
          disabled: true,
        },
        {
          name: "Ro'yxatlar",
          icon: "assets/image/playlist.png",
          activeIcon: "assets/image/playlist-active.png",
          link: "/main/playlist",
          permissions: [110, 120, 130],
          disabled: true,
        },
        {
          name: "Bildirishnomalar",
          icon: "assets/image/notifications.png",
          activeIcon: "assets/image/notifications-active.png",
          link: "/main/notifications",
          customClass: "border-top: 1px solid #dfdcdc;",
          permissions: [110, 120, 130],
          disabled: true,
        },
        {
          name: "Tarix",
          icon: "assets/image/history.png",
          activeIcon: "assets/image/history-active.png",
          link: "/main/history",
          permissions: [110, 120, 130],
          disabled: true,
        },
        {
          name: "Studio",
          icon: "assets/image/studio.png",
          activeIcon: "assets/image/studio.png",
          link: "/main/studio", // Bu dinamik ravishda o'zgaradi
          customClass: "border-top: 1px solid #dfdcdc;",
          permissions: [110, 120, 130],
          disabled: false,
        },
        {
          name: "To'lovlar ro'yxati",
          icon: "assets/image/dollar.png",
          activeIcon: "assets/image/dollar.png",
          link: "/main/payments",
          permissions: [110, 120],
          disabled: false,
        },
        {
          name: "Chiqish",
          icon: "assets/image/logout.png",
          activeIcon: "assets/image/logout.png",
          isLogout: true,
          customClass: "border-top: 1px solid #dfdcdc;",
          permissions: [110, 120, 130],
          disabled: false,
        },
      ],
    };
  },
  created() {
    this.checkLocalStorageData();
  },
  mounted() {
    const token = this.$route.query.access_token
      ? this.$route.query.access_token
      : localStorage.getItem("accessToken");
    localStorage.setItem("accessToken", token);
    this.getExtraData();
  },
  computed: {
    filteredMenuItems() {
      return this.menuItems.filter((item) =>
        this.checkPermission(item.permissions)
      );
    },
  },
  methods: {
    handleRequest(requestData) {
      console.log("So'rov keldi:", requestData);
    },
    updateStudioLink() {
      const studioItem = this.menuItems.find((item) => item.name === "Studio");
      if (studioItem && this.checkPermission([130])) {
        const orgId = this.userInfo.orgId;
        studioItem.link = orgId ? `/main/studio` : "/main/create-organization";
      }
    },
    toggleTheme() {
      this.isDark = !this.isDark;
    },
    checkLocalStorageData() {
      const storedUserInfo = localStorage.getItem("user_info");
      if (storedUserInfo) {
        try {
          const userInfo = JSON.parse(storedUserInfo);
          this.userInfo = userInfo;
          this.permissions =
            userInfo.permissionId !== null ? userInfo.permissionId : [];
          this.isDataLoaded = true;
          this.updateStudioLink();
        } catch (e) {
          console.error("Failed to parse user info from localStorage:", e);
        }
      }
    },
    async getExtraData() {
      try {
        let response = await http.get("/auth/extra-data");
        localStorage.setItem("user_info", JSON.stringify(response.data));
        this.userInfo = response.data;
        this.permissions =
          response.data.permissionId !== null ? response.data.permissionId : [];
        this.isDataLoaded = true;
        this.updateStudioLink();
      } catch (e) {
        if (e.response) {
          console.log(e.response);
          this.checkLocalStorageData();
        }
      }
    },
    checkPermission(allowedPermissions) {
      const userPermissions = this.permissions;
      return allowedPermissions.some((permission) =>
        userPermissions.includes(permission)
      );
    },
    handleLogout() {
      ElMessageBox.confirm("Tizimdan chiqishni hohlaysizmi?", "Diqqat", {
        confirmButtonText: "Ha",
        cancelButtonText: "Yo'q",
        type: "warning",
        center: true,
      })
        .then(() => {
          localStorage.clear();
          ElMessage({
            type: "success",
            message: "Tizimdan chiqdingiz",
          });
          this.$router.push("/");
        })
        .catch(() => {
          ElMessage({
            type: "info",
            message: "Bekor qilindi",
          });
        });
    },
  },
};
</script>

<style scoped></style>
